module.exports = __webpack_public_path__ + "img/newsImg11-35.c8f49138.png";